import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useState } from "react";
import { FileSearch2 } from "lucide-react";

interface FilesDataProps {
  filesCount: {
    tics: number;
    images: number;
    others: number;
    links: number;
    notes: number;
    totalFiles: number;
  };
}

export const FilesData = ({ filesCount }: FilesDataProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div
          className="flex cursor-pointer items-center space-x-2 text-[#71717A]"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <FileSearch2 size={16} />
          <p>{filesCount.totalFiles}</p>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-36 border-none shadow-none">
        <div className="grid gap-2 text-xs">
          <span className="capitalize">Attachment count:</span>

          {Object.entries(filesCount).map(([key, value]) => (
            <div key={key} className="flex space-x-2">
              <span className="capitalize">{key.replace(/([A-Z])/g, " $1")}:</span>
              <span className="font-medium">{value}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
